import { FLOW_CLOSE_MESSAGE } from "@Light/messages";

export function closeParent(): void {
  window.parent.postMessage({ type: FLOW_CLOSE_MESSAGE, payload: {} }, "*");
}
